import { render, staticRenderFns } from "./thirdBlogRow.vue?vue&type=template&id=bf46f3c8&"
import script from "./thirdBlogRow.vue?vue&type=script&lang=js&"
export * from "./thirdBlogRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports